/**
 * Product description: truncate visually with "Read full description"; full HTML stays in DOM for SEO.
 */
(function () {
  function bind(root) {
    var clip = root.querySelector('[data-read-more-clip]');
    var btn = root.querySelector('[data-read-more-toggle]');
    if (!clip || !btn) return;

    function measure() {
      clip.classList.remove('is-expanded');
      btn.hidden = false;
      window.requestAnimationFrame(function () {
        var needsToggle = clip.scrollHeight > clip.clientHeight + 2;
        if (!needsToggle) {
          btn.hidden = true;
          clip.classList.add('is-expanded');
        }
      });
    }

    if (!btn.dataset.readMoreBound) {
      btn.dataset.readMoreBound = 'true';
      btn.addEventListener('click', function () {
        var expanded = clip.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        btn.textContent = expanded ? btn.getAttribute('data-label-less') : btn.getAttribute('data-label-more');
      });
    }

    measure();
  }

  function scan(container) {
    var roots = (container || document).querySelectorAll('[data-product-description-read-more]');
    roots.forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) scan(event.target);
  });
})();
